export default "__VITE_ASSET__DKgKQFwa__"